import { reactive } from '@nuxtjs/composition-api';
import useGoogleMaps from './useGoogleMaps';

export default function usePlacesAutocomplete() {
  const { loader } = useGoogleMaps();

  const autocomplete = reactive({});

  const buildAutocomplete = async (element: any, handler: any, configuration = {}) => {
    const google = await loader.load();

    // @ts-ignore
    autocomplete.value = new google.maps.places.Autocomplete(element, {
      fields: ['address_components'],
      types: ['address'],
      ...configuration,
    });
    // @ts-ignore
    autocomplete.value.addListener('place_changed', handler);
  };

  return {
    autocomplete,
    buildAutocomplete,
  };
}
